export default __webpack_public_path__ + "static/media/TVBook.ac8813abd4cdf24610bab60325f91975.webp";